import { render, staticRenderFns } from "./MerchantsSummary.vue?vue&type=template&id=fc85f64c&"
import script from "./MerchantsSummary.vue?vue&type=script&lang=js&"
export * from "./MerchantsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports